angular.module('CarsSaraBo').factory('AdditionalPriceService', ['$resource', function($resource) {

  return $resource('../rest/company/:companyOid/additionals/:oid',
    { companyOid : '@companyOid', oid : '@oid' },
    {
    	post : {method:'POST' },
    	update : { method: 'PUT' },
    	remove : { method: 'DELETE' },
    	get: {method:'GET', isArray:true},
    	getOne: {method:'GET'}
    }
  )}
]);




//////////////////
// WEBPACK FOOTER
// ./public/app/models/additional_price_service.js
// module id = 836
// module chunks = 3